class BudgetLookup extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("[data-form]");
    this.input = this.querySelector("[data-input]");
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
    this.key = "AIzaSyC4r5CsrNZPBQ02NWNdOlYz0H8IPwL96Y4";
    this.shetID = this.dataset.sheetId;
    this.content = this.querySelector("[data-content]");
    this.error = this.querySelector("[data-error]");
  }

  async fetchData() {
    return await fetch(
      `https://sheets.googleapis.com/v4/spreadsheets/${this.shetID}/values/Sheet1!A1:G4000?key=${this.key}`
    )
      .then((response) => response.json())
      .then((data) => data.values);
  }

  handleSubmit(event) {
    event.preventDefault();
    const value = this.input.value;
    if (value === "") return;
    const user = this.data.find((column) => column[0] === value);
    this.classList.toggle("is-empty", !user);
    if (user) {
      this.renderContent(user);
      this.error.classList.add("hidden");
    } else {
      this.content.innerHTML = "";
      this.error.classList.remove("hidden");
    }
  }
  renderContent(user) {
    const table = `<table style="width: 100%;">
      <thead>
      <tr>
        <td><strong>${this.data[0][0]}</strong></td>
        <td><strong>${this.data[0][1]}</strong></td>
        <td><strong>${this.data[0][3]}</strong></td>
      </tr>
      </thead>
      <tbody>
        <tr>
          <td>${user[0]}</td>
          <td>${user[1]}</td>
          <td>${user[3]}</td>
        </tr>
      </tbody>
    <table>`;
    this.content.innerHTML = table;
  }

  async connectedCallback() {
    this.data = await this.fetchData();
  }
}

customElements.define("budget-lookup", BudgetLookup);
